import React, { useEffect, useState } from "react";
import { Col, Row, Button, Container, Form } from "react-bootstrap";
import "./index.css";
import { getInvoices } from "../../../../actions/structure.action";
import { useDispatch } from "react-redux";
import CustomTable from "../../common/CustomTable";
import { tableStructures } from "../../../../helpers/table-structures";
import { useNavigate } from "react-router-dom";
import { exportOrdersToCSV } from "../../../../utils/exportOrdersToCSV";

const Invoices = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");

  // Set default dates on load
  useEffect(() => {
    const storedFrom = localStorage.getItem("invoiceFromDate");
    const storedTo = localStorage.getItem("invoiceToDate");

    if (storedFrom && storedTo) {
      setFromDate(storedFrom);
      setToDate(storedTo);
    } else {
      const today = new Date();
      const priorDate = new Date();
      priorDate.setDate(today.getDate() - 30);
      const formatDate = (d) => d.toISOString().split("T")[0];
      setToDate(formatDate(today));
      setFromDate(formatDate(priorDate));
      localStorage.setItem("invoiceFromDate", formatDate(priorDate));
      localStorage.setItem("invoiceToDate", formatDate(today));
    }
  }, []);

  const handleRefresh = () => {};

  useEffect(() => {
    // Fetch invoices logic can be added here
    if (fromDate && toDate) {
      getInvoices(dispatch, fromDate, toDate).then((data) => {
        console.log("Invoices data:", data);
        setInvoices(data.payload || []);
      });
    }
  }, [dispatch, fromDate, toDate]);

  return (
    <div>
      <Form className="mb-3 mt-3">
        <Row className="align-items-center px-3">
          {/* Left: Header */}
          {/* Header (left on desktop, full width on mobile) */}
          <Col xs={12} md={4} className="mb-2 mb-md-0">
            <h4 className="m-0">Invoices</h4>
          </Col>
          {/* Filters (right on desktop, full width on mobile) */}
          {/* Right: Filters */}
          <Col xs={12} md={3}>
            {/* Inline label + input for From Date */}
            <div className="d-flex align-items-center">
              <Form.Label className="me-2 mb-0">From</Form.Label>
              <Form.Control
                type="date"
                value={fromDate}
                onChange={(e) => {
                  setFromDate(e.target.value);
                  localStorage.setItem("invoiceFromDate", e.target.value);
                }}
                style={{ minWidth: "140px" }}
              />
            </div>
          </Col>
          <Col xs={12} md={3}>
            {/* Inline label + input for To Date */}
            <div className="d-flex align-items-center">
              <Form.Label className="me-2 mb-0">To</Form.Label>
              <Form.Control
                type="date"
                value={toDate}
                onChange={(e) => {
                  setToDate(e.target.value);
                  localStorage.setItem("invoiceToDate", e.target.value);
                }}
                style={{ minWidth: "140px" }}
              />
            </div>
          </Col>
          <Col xs={12} md={2} className="d-flex justify-content-end m-0 p-0">
            <div className="table-action-box">
              <Button
                buttonClasses="action-button"
                onClick={() => exportOrdersToCSV(invoices)}
                disabled={!invoices.length}
              >
                <i class="bi bi-download"></i> Download All
              </Button>
            </div>
          </Col>
        </Row>
      </Form>
      <Row className="section-row mb-2 mt-0">
        <CustomTable
          enableRowActions
          data={invoices}
          enableTopToolbar={false}
          enableBottomToolbar={true}
          enablePagination={true}
          enableFilters={false}
          emptyTableMsg={`No invoices data found`}
          positionActionsColumn={"last"}
          columns={tableStructures.invoices_seller}
          initialState={{
            columnPinning: {
              right: ["mrt-row-actions"],
            },
          }}
          renderTopToolbarCustomActions={({ table }) => (
            <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
              <h4>My Invoices</h4>
            </Row>
          )}
          renderRowActions={({ row, table }) => (
            <div className="table-action-box">
              <Button
                buttonClasses="action-button"
                id={row.original.id}
                onClick={() => {
                  navigate(`/invoice/${row.original.id}`);
                }}
              >
                <i class="bi bi-download"></i>
              </Button>
            </div>
          )}
        />
      </Row>
    </div>
  );
};

export default Invoices;
